<template>
  <div class="leftMenu">
    <div class="menu">
      <div class="checkMenu" @click="menuCheck" style="cursor: pointer">
        <span>{{foodBookName}}</span>
        <span>></span>
      </div>
      <div class="menuDish">
        <div v-for="(v,i) in menuDishList" :key="i" :class="menuDishClassCurrent == i ? 'menuDishClass' : '' " @click="checkmenuDish(v,i)">
          <img :src="v.img" width="20px" height="20px" style="margin-right: 22px" alt="" />
          {{v.name}}
        </div>
        <!--   <div>
          <img
            src="../../../assets/imgs/bg.jpg"
            width="20px"
            height="20px"
            style="margin-right: 22px"
            alt=""
          />
          欢迎菜
        </div>
        <div>
          <img
            src="../../../assets/imgs/bg.jpg"
            width="20px"
            height="20px"
            style="margin-right: 22px"
            alt=""
          />
          热卖菜
        </div> -->
      </div>
      <div class="menuClass">
        <div class="menuItem" v-for="(v, i) in menuLeft" :key="i" :class="currentac == i ? 'menuItemActive' : ''" @click="currentacClick(v,i)">
          {{ v.description }}
          <div class="menuItemNum" v-if="v.menuNum"> {{v.menuNum}}</div>
        </div>
      </div>
    </div>
    <div class="dishes">
      <div class="leftdishes">
        <div class="CTClassification">
          <div class="ctItem" v-for="(v, i) in cantList" :key="i" :class="current == i ? 'currentCT' : ''" @click="currentCheck(i)">
            {{ v.name }}
          </div>
        </div>

        <div class="tableClassificationThree">
          <div class="tableItem" v-for="(v, i) in tableList" :key="i" :class="v.checked ? 'selectOne' : ''">
            <el-checkbox v-model="v.checked" @change="changeList(v)" style="width:100%;height:100%; position: absolute;;top:0;left:0;z-index:1000"></el-checkbox>
            <div class="tableName">
            
              <el-image :src="imgBaseurl+ v.standardPics" lazy fit="cover" style="height:100%;width:140px">
                <div slot="error" class="image-slot">
                  <img src="../../../assets/imgs/none.png" width="140px" height="100%" alt="" />
                </div>
              </el-image>
            </div>
            <div class="rightName">
              <div class="name" style="color: #666666; font-size: 28px; margin-bottom: 10px">
                {{ v.foodDishesName }}
              </div>
              <div class="topImg">
                <img src="../../../assets/imgs/hot.png" v-if="v.isHotFood" width="20" height="20" alt="">
                <img src="../../../assets/imgs/hyc.png" v-if="v.isWelcomeFood" width="20" height="20" alt="">
                <img src="../../../assets/imgs/tjc.png" v-if="v.isRecommendFood" width="20" height="20" alt="">
              </div>
              <!--  <div style="margin-bottom:5px">
                <img v-if="v.is_hot_food" src="../../../assets/imgs/hot.png" width="20px" height="20px" alt="">
                <img v-if="v.is_welcome_food" src="../../../assets/imgs/hyc.png" width="20px" height="20px" alt="">
                <img v-if="v.is_recommend_food" src="../../../assets/imgs/tjc.png" width="20px" height="20px" alt="">
                <div v-else-if="menuDishClassCurrent == 3" style="width:20px;height:25px"></div>
                <div v-else-if="menuDishClassCurrent == 4" style="width:20px;height:25px"></div>
              </div> -->
              <div class="tableNum">
                <span style="color: #fe8d30; font-size: 20px">￥{{ v.unitPrice2.toFixed(2) }}
                </span>
                <span style="font-size: 16px" v-if="v.estimateCount">沽清{{ v.estimateCount }} </span>
              </div>
            </div>
            <div class="Mantle" v-if="menuDishClassCurrent == 3">
              <i class="el-icon-lock"></i>
            </div>
          </div>
        </div>

        <div class="tableBottom">
          <div class="checkStyle">
            <el-date-picker v-model="timevalue1" type="date" placeholder="选择日期">
            </el-date-picker>
          </div>

          <div>
            <el-input placeholder="输入菜品编码、助记码、条形码查询" v-model="inputSearch" clearable style="width: 300px; height: 50px; line-height: 50px">
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="切换菜谱" :visible.sync="menuCheckDialog" width="750px" center>
      <div class="menuTTT">
        <div v-for="(v, i) in menuCheckList" :key="i" class="menuItemName" :class="menuCheckCurrentItem == i ? 'menuItemNameCurrent' : ''" @click="menuNameCheck(v,i)">
          <div>
            {{ v.description }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    message: Number
  },
  data() {
    return {
      datastatus: 0,
      ischecked: false,
      timevalue1: '',
      imgBaseurl: 'http://pmsoss.rooibook.com/',
      menuCheckCurrentItem: 0,
      menuDishList: [
        { name: '推荐菜', img: require('../../../assets/imgs/tjc.png') },
        { name: '欢迎菜', img: require('../../../assets/imgs/hyc.png') },
        { name: '热卖菜', img: require('../../../assets/imgs/hot.png') },
        { name: '已锁菜', img: require('../../../assets/imgs/cj.png') },
        { name: '已估清', img: require('../../../assets/imgs/gq.png') },
      ],
      menuCheckList: [],
      menuCheckDialog: false,
      styleCurrent: 3,
      styleList: [
        { imgUrl: require("../../../assets/imgs/LOGO.png") },
        { imgUrl: require("../../../assets/imgs/LOGO.png") },
        { imgUrl: require("../../../assets/imgs/LOGO.png") },
        { imgUrl: require("../../../assets/imgs/LOGO.png") },
      ],
      inputSearch: "",
      menuLeft: [
        "沙拉",
        "前菜",
        "主菜",
        "brunch",
        "酒水",
        "饮料",
        "饮料",
        "饮料",
        "饮料",
      ],
      foodBookId: '',
      foodBookName: '',
      current: 0,
      currentac: -1,
      menuDishClassCurrent: -1,
      menuNum: 0,
      cantList: [{ name: "零点" }, { name: "计时" }, { name: "套餐" }],
      tableNumberList: [
        { num: "59", name: "所有", bgcolor: "#fff", color: "#666" },
        { num: "59", name: "空闲", bgcolor: "#fff", color: "#666" },
        { num: "59", name: "预订", bgcolor: "#5E93FB", color: "#fff" },
        { num: "59", name: "开台", bgcolor: "#00CDC1", color: "#fff" },
        { num: "59", name: "点菜", bgcolor: "#AACC1E", color: "#fff" },
        { num: "59", name: "送单", bgcolor: "#3BCC1E", color: "#fff" },
        { num: "59", name: "上菜", bgcolor: "#FE9D24", color: "#fff" },
        { num: "59", name: "脏台", bgcolor: "#5C656E", color: "#fff" },
        { num: "59", name: "挂单", bgcolor: "#C293FE", color: "#fff" },
        { num: "59", name: "维修", bgcolor: "#FF3C62", color: "#fff" },
      ],
      tableList: [

      ],
      flag: true,
      changeListArr: [],
      gqARR: [],
    };
  },
  created() {
    this.fetchFoodBook()
    this.getMealList()
    console.log(this.message);
  },
  watch: {
    message(val) {
      this.message = val
      if (this.message == 1) {
        this.tableList.forEach(val => {
          val.checked = false
        })

      }
    }
  },
  mounted() {

  },
  methods: {
    changeList(v) {
      this.changeListArr = []
      this.gqARR = []
      if (this.changeListArr.length == 0) {
        this.$emit('changemessage', 0);
      }
      this.tableList.forEach(val => {
        if (val.checked) {
          console.log(val);
          this.changeListArr.push(val.foodDishesId)
          this.gqARR.push(val.estimateId)

        }

      })
      this.$emit('gqARR', this.gqARR)
      this.$emit('changeListArr', this.changeListArr)
      this.$emit('currentCheck', this.current)


    },
    getMealList() {
      let url = this.api.getappList
      let methods = 'post'
      let data = {
        foodBookId: this.foodBookId,
        type: this.current + 1,
        isRecommendFood: this.isRecommendFood,
        isWelcomeFood: this.isWelcomeFood,
        isHotFood: this.isHotFood,
        isLock: this.isLock,
        isEstimate: this.isEstimate,
        foodTypeId: this.foodTypeId,
      }
      this.$axios({ url, methods, data }).then(res => {
        this.tableList = res.data.data
        this.tableList.forEach(v => {
          this.$set(v, 'checked', false)
        })
      })
    },
    fetchFoodBook() {
      let url = this.api.getFoodBookList
      let methods = 'get'
      this.$axios({ url, methods }).then(res => {
        console.log(res);
        this.menuCheckList = res.data.data
        this.menuCheckList.sort((a, b) => { return a.code - b.code })//升序
        this.foodBookName = res.data.data[0].description
        this.foodBookId = res.data.data[0].id

        this.getFoodTypeMap(res.data.data[0].id)
      })
    },
    getFoodTypeMap(foodBookId) {
      let url = this.api.getFoodTypeMap
      let methods = 'get'
      let data = {
        foodBookId: foodBookId,
      }
      this.$axios({ url, methods, data }).then(res => {
        console.log(res);
        this.menuLeft = res.data.data
        this.menuLeft.forEach(v => {
          v.menuNum = 0;
          this.$set(v, 'menuNum', 0)
        })
      })
    },
    checkmenuDish(v, i) {
      if (this.menuDishClassCurrent !== i) {
        this.menuDishClassCurrent = i
      } else {
        this.menuDishClassCurrent = -1
      }
      if (this.menuDishClassCurrent == 0) {
        this.isRecommendFood = 1
        this.isWelcomeFood = ''
        this.isHotFood = ''
        this.isLock = ''
        this.isEstimate = ''
        this.getMealList()
      } else if (this.menuDishClassCurrent == 1) {
        this.isRecommendFood = ''
        this.isWelcomeFood = 1
        this.isHotFood = ''
        this.isLock = ''
        this.isEstimate = ''
        this.getMealList()
      } else if (this.menuDishClassCurrent == 2) {
        this.isHotFood = 1
        this.isRecommendFood = ''
        this.isWelcomeFood = ''
        this.isLock = ''
        this.isEstimate = ''
        this.getMealList()
      } else if (this.menuDishClassCurrent == 3) {
        this.isLock = 1
        this.isRecommendFood = ''
        this.isWelcomeFood = ''
        this.isHotFood = ''
        this.isEstimate = ''
        this.getMealList()
      } else if (this.menuDishClassCurrent == 4) {
        this.isEstimate = 1
        this.isRecommendFood = ''
        this.isWelcomeFood = ''
        this.isHotFood = ''
        this.isLock = ''
        this.getMealList()
      } else if (this.menuDishClassCurrent == -1) {
        this.isRecommendFood = ''
        this.isWelcomeFood = ''
        this.isHotFood = ''
        this.isLock = ''
        this.isEstimate = ''

        this.getMealList()
      }
      this.$emit('currentCheck', this.current)
      this.$emit('currentac', this.menuDishClassCurrent)
    },
    currentacClick(v, i) {
      if (this.currentac !== i) {
        this.currentac = i
        this.foodTypeId = v.id
        this.getMealList()
      } else {
        this.currentac = -1
        this.getMealList(this.current + 1)
      }
      this.$emit('currentac', -1)

    },
    /*   menuNameCheck(i) {
        this.menuCheckCurrentItem = i;
      }, */
    menuNameCheck(v, i) {
      let url = this.api.getappList
      let methods = 'post'
      let data = {
        type: this.current + 1,
        foodBookId: v.id,
      }
      // data = JSON.stringify(data)
      this.$axios({ url, methods, data }).then(res => {
        console.log(res);
        this.foodBookName = v.description
        this.tableList = res.data.data
        this.menuCheckCurrentItem = i;
        this.menuCheckDialog = false;
      })
    },
    menuCheck() {
      this.fetchFoodBook()
      this.menuCheckDialog = true;
    },
    styleCheck(i) {
      console.log(i);
    },
    currentCheck(i) {
      this.isRecommendFood = 0
      this.isWelcomeFood = 0
      this.isHotFood = 0
      this.isLock = 0
      this.isEstimate = 0
      this.menuDishClassCurrent = -1
      this.currentac = -1
      this.current = i;
      let url = this.api.getappList
      let methods = 'post'
      let data = {
        type: this.current + 1,
      }
      this.$emit('currentCheck', i)
      // data = JSON.stringify(data)
      this.$axios({ url, methods, data }).then(res => {
        console.log(res);
        this.tableList = res.data.data
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.selectOne {
  background: #edf8ff;
  border: 2px solid #0099ff !important;
}
.leftMenu {
  width: 100%;

  height: 100%;
  display: flex;
  .menu {
    width: 260px;

    height: 100%;
    border-right: 1px solid #eaeaea;
    .checkMenu {
      height: 66px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 30px;
      border-bottom: 1px solid #eaeaea;
      span:nth-child(1) {
        font-size: 24px;
        color: #0099ff;
      }
      span:nth-child(2) {
        font-size: 18px;
        color: #666666;
      }
    }
    .menuDish {
      height: 327px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;
      border-bottom: 1px solid #eaeaea;
      color: #666;
      div {
        height: 20%;
        display: flex;
        align-items: center;
        padding-left: 42px;
        cursor: pointer;
        width: 100%;
      }
      .menuDishClass {
        background: #0099ff;
        color: #fff;
      }
    }
    .menuClass {
      overflow-y: auto;
      height: 100%;
      height: calc(100% - 400px);

      .menuItem {
        width: 100%;
        height: 66px;
        display: flex;
        align-items: center;
        padding-left: 40px;
        padding-right: 20px;
        font-size: 24px;
        color: #666;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        .menuItemNum {
          width: 22px;
          height: 22px;
          background: #f5581a;
          text-align: center;
          line-height: 22px;
          border-radius: 11px;
          color: #fff;
          font-size: 14px;
        }
      }
      .menuItemActive {
        background: #0099ff;
        color: #fff;
      }
    }
  }
  .dishes {
    // width: calc(100% - 250px);
    width: 100%;
    height: 100%;

    .leftdishes {
      width: 100%;
      height: 100%;

      margin-right: 10px;
      border-radius: 20px;

      .CTClassification {
        display: flex;
        justify-content: center;
        margin: 13px 0;

        .ctItem {
          width: 130px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 20px;
          color: #666666;
          cursor: pointer;
        }
        .currentCT {
          background: #0099ff;
          color: #fff;
        }
      }

      .tableClassificationThree {
        padding: 0 10px;
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 150px);
        align-content: flex-start;
        overflow-y: auto;
        .tableItem {
          cursor: pointer;
          width: 30.2%;
          height: 124px;
          border: 1px solid #eaeaea;
          border-radius: 6px;
          display: flex;
          color: #666;
          margin: 5px;
          position: relative;
          /deep/.el-checkbox__inner {
            width: 0;
            height: 0;
            border: none;
          }
          /deep/.el-checkbox__inner::after {
            width: 0;
            height: 0;
            border: none;
          }

          .tableNum {
            width: 100%;
            align-items: flex-end;
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
          }
          .rightName {
            width: 100%;
            padding: 20px 10px 12px 10px;
          }
          .Mantle {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            position: absolute;
            top: 0;
            left: 0;
            padding: 42px 0 0 52px;
            .el-icon-lock {
              color: #fff;
              font-size: 40px;
            }
          }
          .topImg {
            position: absolute;
            left: 150px;
            top: 55px;
          }
        }
      }

      .tableBottom {
        height: 70px;
        display: flex;
        padding: 15px 36px 0 36px;
        align-items: center;

        .checkStyle {
          display: flex;
          margin-right: 30px;
        }
      }
    }
  }
}
.tableName {
  width: 140px;
  // height: 100%;
}
</style>
<style lang="scss" scoped>
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
}
/deep/.el-dialog__header {
  margin-top: 50px;
  background: #fff;
}
/deep/.el-dialog__title {
  color: #0099ff;
  font-size: 28px;
}

/deep/.el-dialog__body {
  height: 322px;
  overflow: hidden;
}
.menuTTT {
  width: 100%;
  display: flex;
  justify-content: space-around;
  .menuItemName {
    width: 190px;
    height: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 48px;
    background: #eeeeee;
    border-radius: 20px;
    color: #666667;
    margin: 0 15px;
    cursor: pointer;
    div {
      width: 120px;
      text-align: center;
    }
  }
  .menuItemNameCurrent {
    background: #0099ff;
    color: #fff;
  }
}
</style>